/* eslint-disable no-param-reassign */
import { PayloadAction } from "@reduxjs/toolkit"

import { HealthReducerState } from "./types"

export function setAPIHealthHandler(
  state: HealthReducerState,
  action: PayloadAction<HealthReducerState>
) {
  state.endpointHealth = action.payload.endpointHealth
}
